import { createSvgIcon } from '@mui/material';

const TaktischesZeichen = createSvgIcon(<path d="M12,0 l12,12 -12,12 -12,-12z m-4,6.5 l-5.5,5.5 9.5,9.5 9.5,-9.5 -5.5,-5.5z" />, 'TaktischesZeichen');

export default TaktischesZeichen;
